module.exports = __webpack_public_path__ + "img/service-01-pic-6.31268870.jpg";